<template>
    <template v-if="[undefined, 'success'].includes(validateInfo?.validateStatus)">
        <CSelect
            :value="valueComputed"
            @select="value => onSelect({ props, value })"
            @deselect="value => onDeselect({ props, value })"
            :list="() => masterAttribute"
            optKey="key"
            optLabel="desc"
            mode="multiple"
            :selectWithIsSave="false"
            :disabled="viewOnly"
            :placeholder="$t('model.resource.attribute')"
        ></CSelect>
    </template>
    <template v-else>
        <div class="text-danger">{{ validateInfo?.help }}</div>
    </template>
</template>

<script>
import { computed, defineComponent, watch, defineAsyncComponent } from "vue";
import { mapAttribute, onSelect, onDeselect, crossCheck } from "./attribute-select.logic";

export default defineComponent({
    components: {
        CSelect: defineAsyncComponent(() => import("../../../../../components/input/template-builder/select/CSelect"))
    },
    props: {
        viewOnly: { default: false },
        masterAttribute: {},
        record: {},
        validateInfo: {}
    },
    setup(props) {
        const valueComputed = computed(() => mapAttribute({ props }));
        watch(
            () => props.masterAttribute,
            () => crossCheck({ props }),
            { flush: "post" }
        );
        return { props, valueComputed, onSelect, onDeselect };
    }
});
</script>
